(() => {
  if (window.Shopify && Shopify.designMode) return;
  if (window.location.hash) return;

  const navEntry = performance.getEntriesByType
    ? performance.getEntriesByType('navigation')[0]
    : null;

  if (navEntry && navEntry.type === 'back_forward') return;

  const scrollToProduct = () => {
    const frame = document.querySelector('.product-decision-frame-container');
    if (!frame) return;

    const top = Math.max(0, frame.getBoundingClientRect().top + window.pageYOffset - 16);
    window.scrollTo({ top, behavior: 'auto' });
  };

  const scheduleScroll = () => {
    requestAnimationFrame(() => {
      scrollToProduct();
      window.setTimeout(scrollToProduct, 120);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScroll, { once: true });
  } else {
    scheduleScroll();
  }
})();
